import React from 'react'
import styled from 'styled-components'
import Navbar from '../components/Navbar'
import Announcement from  "../components/Announcement"
import Footer from  "../components/Footer"
import Categories from '../components/Categories'
import RentalAnnouncement from '../components/RentalAnnouncement'
import AllDataLine from '../components/AllDataLine'

const Container = styled.div`

`;
const Title = styled.h1`
    margin: 20px;
    font-size: 40px;
`;

const ProductList = () => {
  return (
    <Container>
        <Navbar/>
        <Announcement/>
        <Title>Rental & Sale Products:</Title>
        <AllDataLine/>
        <RentalAnnouncement/>
        <Categories/>
        <Footer/>
    </Container>
  );
};

export default ProductList